import React, { Children, useEffect, useState } from 'react'
import { dateFormatter } from '@fareye/common'
import { terminalView } from '@fareye/configs'
import { Flex, styled } from '@fareye/ui'
const AllTimeContainer: any = styled(Flex)`
  margin-left: auto;
`
const TimeContainer: any = styled(Flex)`
  justify-content: flex-end;
  align-items: center;
  margin-left: 20px;
  background: ${terminalView.darkTheme.timer.background};
  border-radius: 12px;
  flex: none;
  order: 0;
  flex-grow: 0;
  height: 48px;
  padding: 0px 16px;
  @media (min-width: 1920px) and (max-width: 3840px) {
    padding-right: 30px;
    padding-left: 20px;
    height: 52px;
  }
  @media (min-width: 3840px) {
    padding-right: 40px;
    padding-left: 20px;
    margin-left: 100px;
    height: 144px;
  }
`
const TimeFontStyleContainer: any = styled(Flex)`
  font-family: 'Digital Numbers';
  color: ${terminalView.darkTheme.timer.color};
  flex: none;
  order: 0;
  flex-grow: 0;
  @media (max-width: 3840px) {
    font-weight: 400;
    font-size: 18px;
  }
  @media (min-width: 3840px) {
    font-weight: 400;
    font-size: 64px;
  }
`

const Timer = ({ children }: any) => {
  return (
    <AllTimeContainer>
      <TimeContainer>
        <TimeFontStyleContainer>
          {dateFormatter(new Date(Date.now()).toISOString(), 'hhmmaz')}
        </TimeFontStyleContainer>
      </TimeContainer>
    </AllTimeContainer>
  )
}
export { Timer }
